import React from "react";

import { IntegratorProvider } from "../context/IntegratorProvider";
import { IntegratorListing } from "./IntegratorListing";

export const IntegratorDashboard: React.FC = () => {
    return (
        <>
            <IntegratorProvider>
                <IntegratorListing />
            </IntegratorProvider>
        </>
    );
};
